import { render } from "./ListeTypeChambre.vue?vue&type=template&id=130cd484&scoped=true"
import script from "./ListeTypeChambre.vue?vue&type=script&lang=js"
export * from "./ListeTypeChambre.vue?vue&type=script&lang=js"

import "./ListeTypeChambre.vue?vue&type=style&index=0&id=130cd484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130cd484"]])

export default __exports__